<template>
	<div
		:class="[relativePos(pos), { 'my-cards': shown }]"
		class="card-container"
	>
		<div class="player-container">
			<p
				class="player-label"
				:class="{ 'current-turn': turn, disconnected: isDisconnected }"
			>
				{{ name }} ({{ pos }})
			</p>
		</div>
		<ul class="cards-list">
			<Card
				v-for="card in cards"
				:key="card.id"
				:value="card.value"
				:suit="card.suit"
				:shown="shown"
				:class="{ 'hidden-turn': turn, mine: shown }"
				@click="shown && handleCardClick(card.value)"
			/>
		</ul>
	</div>
</template>

<script>
import Card from "./Card";
import { mapGetters } from "vuex";

export default {
	props: {
		cards: Array,
		name: String,
		turn: Boolean,
		shown: Boolean,
		pos: Number,
		me: Number,
	},
	components: {
		Card,
	},
	computed: {
		...mapGetters(["disconnectedPlayers"]),
		isDisconnected() {
			return this.disconnectedPlayers.includes(this.pos);
		},
	},
	emits: ["card-value-click"],
	methods: {
		relativePos(pos) {
			// How many positions ahead of me?
			let relative = (4 + pos - this.me) % 4;

			// Return appropriate word
			switch (relative) {
				case 0:
					return "bottom";
				case 1:
					return "left";
				case 2:
					return "top";
				case 3:
					return "right";
			}
		},
		handleCardClick(aVal) {
			this.$emit("card-value-click", aVal);
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

.card-container {
	text-align: center;

	display: flex;
	flex-direction: column;
	height: 100%;
	&.my-cards {
		max-height: 170px;
	}
	max-height: 150px;

	.player-container {
		margin-bottom: 8px;
		.player-label {
			display: inline-block;
			font-size: 1.1em;
			font-weight: bold;
			padding: 4px 16px;
			border-radius: $border-m;
			transition: 0.4s;

			&.current-turn {
				font-size: 1.5em;
				background-color: $blue-lighter;
				box-shadow: 0px 3px $blue-darker;
			}

			&.disconnected {
				color: $red;
			}
		}
	}

	.cards-list {
		height: 100%;
		.card {
			transition: 0.4s;
			margin: 0px -16px;
			&.hidden-turn {
				transform: scale(1.05);
				transform-origin: center top;
			}
			&.mine {
				transition: 0.6s;
				&.hidden-turn {
					transform-origin: center bottom;
				}
			}
		}
	}
}
</style>
